import React from 'react';
import { Helmet } from 'react-helmet';
import Footer from '../components/Contacto';

interface Sucursal {
  id: number;
  nombre: string;
  direccion: string;
  horario: string;
  telefono: string;
  whatsapp?: string;
  mapsLink: string;
  imagen: string;
}

const sucursales: Sucursal[] = [
  {
    id: 1,
    nombre: 'Matriz',
    direccion: 'Av. División del Nte. 4405, Coapa, Ex de San Juan de Dios, Tlalpan, CDMX',
    horario: 'Lunes a Domingo: 9 AM - 6 PM',
    telefono: '55 6603 0293',
    whatsapp: '55 7511 0551',
    mapsLink: 'https://www.google.com/maps/place/El+Chel/@19.294668,-99.1413122,16z',
    imagen: '/img/suc1.png',
  },
  {
    id: 2,
    nombre: 'Cuemanco',
    direccion: 'Cañaverales 39, Coapa, Magisterial, Tlalpan, CDMX',
    horario: 'Lunes a Domingo: 9 AM - 6 PM',
    telefono: '55 9278 4907',
    whatsapp: '55 7181 0812',
    mapsLink: 'https://www.google.com/maps/place/El+Chel/@19.294324,-99.141112,14z',
    imagen: '/img/suc2.png',
  },
];

const Sucursales: React.FC = () => {
  return (
    <div className="w-full px-6 py-8 font-[Arial,sans-serif] bg-[#05603c]">
      <Helmet>
        <title>Sucursales | El Chel</title>
        <meta name="description" content="Encuentra todas las sucursales de El Chel en Tlalpan, CDMX. Horarios, teléfonos y cómo llegar." />
      </Helmet>

      <h1 className="text-[2rem] text-white text-center mb-6 font-bold">Nuestras Sucursales</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 max-w-[1100px] mx-auto">
        {sucursales.map((sucursal) => (
          <div
            key={sucursal.id}
            className="p-5 rounded-[12px] text-left bg-gradient-brand shadow-brand-strong"
          >
            <h2 className="text-2xl text-white font-bold mb-2">{sucursal.nombre}</h2>
            <p className="text-base text-white mb-2"><strong>Dirección:</strong> {sucursal.direccion}</p>
            <p className="text-base text-white mb-2"><strong>Horario:</strong> {sucursal.horario}</p>
            <p className="text-base text-white mb-2"><strong>Teléfono:</strong> {sucursal.telefono}</p>
            {sucursal.whatsapp && (
              <p className="text-base text-white mb-2"><strong>WhatsApp:</strong> {sucursal.whatsapp}</p>
            )}
            <a href={sucursal.mapsLink} target="_blank" rel="noopener noreferrer">
              <img
                src={sucursal.imagen}
                alt={sucursal.nombre}
                loading="lazy"
                className="w-full h-auto rounded-[8px] mt-3 border-2 border-[#ff6d00]"
              />
            </a>
            <a
              href={sucursal.mapsLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#ff6d00] no-underline font-bold text-base hover:text-white hover:underline block mt-2"
            >
              Ver en Google Maps 📍
            </a>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default Sucursales;
